module.exports = __webpack_public_path__ + "static/media/nuvemshop2.50f6630f.png";